import { Injectable, inject } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from './auth.service';
import {map, take, tap} from 'rxjs/operators';
import {Logger} from '../utils/logger';

@Injectable({
  providedIn: 'root'
})
export class LoginGuardService implements CanActivate {
  private auth = inject(AuthService);
  private router = inject(Router);


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.auth.currentUserObservable.pipe(
      take(1),
      map(user => {
        if(!!user){
          if(user.isAnonymous){
            this.auth.signOut();
            return true;
          }else if(user.emailVerified){
            return false;
          } else if(!user.emailVerified) {
            return true;
          }
        }else{
          return true;
        }
      }),
      tap(notLoggedIn => {
        if (!notLoggedIn) {
          Logger.log('LoginGuardService 11');
          this.router.navigate(['/dashboard']);
        }
      })
    );
  }

}
